import { Breadcrumbs, FormLabel, Link, Typography } from "@mui/material";
import { useMaquinasEquipCadastroPrincipalViewModel } from "../../viewModels/maquinas_equip_cadastro_principal_view_model";
import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { Link as LinkTo } from "react-router";
import { GetAllMaquinaEquipArquivoDaoModel } from "../../../domain/models/MaquinasEquipItensArquivo";
import { GeneratePatrimonioArquivoColumnDefinition } from "./columns/AnexarDocumentos";
import { MaquinasequipContent } from "./components/Maquinasequip_cadastro";
import { isValidId } from "../../../../../common/utils/utils";
import { ControlePatrimonioArquivoModal } from "./components/controle_patrimonio_arquivo_modal";

import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import BottomBar from "../../../../../common/components/bottom_bar";
import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

export const MaquinasequipCadastroPrincipal = () => {
  const viewModel = useMaquinasEquipCadastroPrincipalViewModel();

  const columnsDefinition = useMemo(() => {
    return GeneratePatrimonioArquivoColumnDefinition({
      onActionEditar: viewModel.handleControlePatrimonioArquivoModalOpenState,
      onActionDeletar:
        viewModel.handleControlePatrimonioArquivoDeleteModalOpenState,
      onActionDownload: viewModel.handleControlePatrimonioArquivoDownload,
    });
  }, [
    viewModel.handleControlePatrimonioArquivoDownload,
    viewModel.handleControlePatrimonioArquivoDeleteModalOpenState,
    viewModel.handleControlePatrimonioArquivoModalOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div>
                <BackButton onClick={() => viewModel.handleBack()} />
              </div>
            </div>
          }
        />
      </PageTopBar>

      <form onSubmit={viewModel.handleControlePatrimonioSubmit}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Patrimônio
            </Link>

            <Link underline="hover" color="inherit" component="span">
              <LinkTo to="/MaquinasEquip_lista"> Controle de Patrimônio</LinkTo>
            </Link>
            <Typography className="text-primary-green">
              Cadastro de Controle de Patrimônio
            </Typography>
          </Breadcrumbs>

          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">
              Cadastro de Controle de Patrimônio
            </h1>
            <RefreshButton onClick={() => viewModel.handleReload()} />
          </div>

          <div className="w-full flex flex-col gap-2">
            {viewModel.errorMessage !== undefined ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                <MaquinasequipContent
                  saving={viewModel.saving}
                  centroCustoDropdown={viewModel.centroCustoDropdown}
                  fornecedorDropdown={viewModel.fornecedorDropdown}
                  funcionarioMonitDropdown={viewModel.funcionarioMonitDropdown}
                  funcionarioRespDropdown={viewModel.funcionarioRespDropdown}
                  hookForm={viewModel.hookForm}
                />

                {viewModel.idControlePatrimonio && (
                  <>
                    <div className="w-full justify-between flex gap-2">
                      <FormLabel className="flex-shrink-0">
                        Anexar Documento
                      </FormLabel>
                      <div className="">
                        <PrimaryButton
                          startIcon={
                            <DynamicIcon
                              nameIcon="AddRounded"
                              size={25}
                              className="text-white"
                            />
                          }
                          onClick={() =>
                            viewModel.handleControlePatrimonioArquivoModalOpenState(
                              null,
                              true,
                            )
                          }
                        >
                          Novo Item
                        </PrimaryButton>
                      </div>
                    </div>

                    <StyledDataGrid
                      tableName="MaquinaEquipArquivos"
                      disableColumnMenu={false}
                      showToolbar={true}
                      disableRowSelectionOnClick={true}
                      getRowId={(row: GetAllMaquinaEquipArquivoDaoModel) =>
                        row.idMaquinaEquipArquivo ?? ""
                      }
                      columns={columnsDefinition}
                      loading={viewModel.loading}
                      checkboxSelection={false}
                      rows={viewModel.controlePatrimonioArquivos}
                      rowCount={
                        viewModel.controlePatrimonioArquivos?.length ?? 0
                      }
                      pageSizeOptions={[10, 25, 50, 100]}
                      paginationMode="server"
                      paginationModel={{
                        page: viewModel.pagination.page,
                        pageSize: viewModel.pagination.rowsPerPage,
                      }}
                    />
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.idControlePatrimonio) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory()}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>

            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleBack}
                >
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      <ControlePatrimonioArquivoModal
        open={viewModel.controlePatrimonioArquivoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedControlePatrimonioArquivo={
          viewModel.selectedControlePatrimonioArquivo
        }
        onClose={() =>
          viewModel.handleControlePatrimonioArquivoModalOpenState(null, false)
        }
        onSubmit={viewModel.handleControlePatrimonioArquivoModalSubmit}
        onDownloadFile={viewModel.handleControlePatrimonioArquivoDownload}
      />

      <DeleteDialog
        open={viewModel.controlePatrimonioArquivoDeleteModal}
        title={`Você realmente deseja excluir este item?`}
        onClose={() =>
          viewModel.handleControlePatrimonioArquivoDeleteModalOpenState(
            null,
            false,
          )
        }
        onDelete={() => viewModel.handleControlePatrimonioArquivoDeleteSubmit()}
      />

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
    </>
  );
};
